import './src/styles/tokens.css'
import './src/styles/utilities.css'
import './src/styles/cursor.css'
import './src/styles/nav.css'
import './src/styles/hero.css'
import './src/styles/anatomy.css'
import './src/styles/agents.css'
import './src/styles/morning-brief.css'
import './src/styles/security.css'
import './src/styles/process.css'
import './src/styles/testimonials.css'
import './src/styles/membership.css'
import './src/styles/invitation-form.css'
import './src/styles/footer.css'
import './src/styles/gdpr.css'
import './src/styles/legal.css'
import './src/styles/responsive.css'

// Google Fonts (preconnects + stylesheet) are injected server-side in gatsby-ssr.js
// so they land in the initial HTML <head>. Re-injecting them here duplicated the
// preconnects (flagged as "unused" by Lighthouse) and re-requested the stylesheet.

// Respect hash anchors on cross-page navigation (e.g. legal pages → /#invitation)
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    setTimeout(() => {
      const el = document.querySelector(location.hash)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }, 100)
    return false
  }
  return true
}
